<script setup>
import { ref } from "vue";

defineProps({
    modelValue: String,
    readonly: {
        type: Boolean,
        default: () => false,
    },
});

defineEmits(["update:modelValue"]);

// Delegate imperative focus handling to the wrapped el-input so parent
// components using a template ref (e.g. ConfirmsPassword) keep working.
const input = ref(null);

defineExpose({
    focus: () => input.value?.focus(),
    blur: () => input.value?.blur(),
    select: () => input.value?.select(),
});
</script>

<template>
    <el-input
        ref="input"
        size="large"
        class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm"
        v-bind="$attrs"
        :readonly="readonly"
        :model-value="modelValue"
        @input="$emit('update:modelValue', $event)"
    >
        <template v-if="$slots.append" #append>
            <slot name="append"></slot>
        </template>
        <slot v-if="$slots.default"></slot>
    </el-input>
</template>
